const state = {
  loader: false,
  panelOpen: false,
  burgerActive: false,
  isOffset: false,
}

const mutations = {
  setLoader(state, payload) {
    state.loader = payload
  },
  setPanel(state, payload) {
    state.panelOpen = payload
  },
  setBurger(state, payload) {
    state.burgerActive = payload
  },
  setOffset(state, payload) {
    state.isOffset = payload
  },
}

const getters = {
  isLoading(state) {
    return state.loader
  },
  isPanelOpen(state) {
    return state.panelOpen
  },
  isBurgerActive(state) {
    return state.burgerActive
  },
  isOffset(state) {
    return state.isOffset
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
